import axios from "axios";
import { getAPIURL } from "./";
axios.defaults.withCredentials = true;

/**
 * Add a misting request
 * @param duration The number of seconds you want to mist
 */
export const RequestMist = (duration: number): Promise<any> => {
  return axios
    .post<any>(getAPIURL("MistingRequest/AddMistingRequest"), {
      Duration: duration,
    })
    .then((response) => {
      return response.data;
    });
};
